// apps/landing-page/src/components/personalization/PersonalizationChip.tsx
'use client';

import { ChevronRight, SlidersHorizontal } from 'lucide-react';
import { useTranslations } from 'next-intl';
import type { AudienceSegment } from '@/context/PreferencesContext';

interface PersonalizationChipProps {
  segment: AudienceSegment | null;
  onClick: () => void;
}

// Always-available slim entry point for the personalization modal. Renders
// beside the Catalog section heading (a filter control next to what it
// filters) rather than as its own standalone band — this is a proper
// clickable trigger (cursor-pointer, designed hover/focus), not a static
// card. See docs/personalization-spec.md.
export function PersonalizationChip({ segment, onClick }: PersonalizationChipProps) {
  const t = useTranslations('personalization');
  const label = segment
    ? t('chipLabelWithSegment', { segment: t(`segments.${segment}.label`) })
    : t('chipLabel');

  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition-all cursor-pointer hover:border-teal-300 hover:bg-teal-50/60 hover:text-teal-700 hover:shadow-md"
    >
      <SlidersHorizontal className="w-4 h-4 text-teal-600" />
      {label}
      <ChevronRight className="w-4 h-4 text-slate-300" />
    </button>
  );
}
